var _ellipse, _ellipse2, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 340,
    viewBox: "0 0 342 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.028,
    cy: 170,
    rx: 170.343,
    ry: 170,
    fill: "url(#paint0_linear_241_933)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.028,
    cy: 170,
    rx: 150.25,
    ry: 149.947,
    fill: "url(#paint1_linear_241_933)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.518 170C302.518 242.471 243.65 301.223 171.028 301.223C98.4066 301.223 39.5386 242.471 39.5386 170C39.5386 97.5292 98.4066 38.7768 171.028 38.7768C243.65 38.7768 302.518 97.5292 302.518 170Z",
    stroke: "url(#paint2_linear_241_933)",
    strokeWidth: 1.93
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 137.782,
    y: 226.355,
    width: 33.5887,
    height: 33.5887,
    fill: "white",
    fillOpacity: 0.64
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 171.371,
    y: 226.355,
    width: 33.5887,
    height: 33.5887,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 171.371,
    y: 192.766,
    width: 33.5887,
    height: 33.5887,
    fill: "white",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 204.636,
    y: 192.766,
    width: 33.5887,
    height: 33.5887,
    fill: "white",
    fillOpacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 104.193,
    y: 192.68,
    width: 33.5887,
    height: 33.5887,
    fill: "white",
    fillOpacity: 0.94
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 204.636,
    y: 159.177,
    width: 33.5887,
    height: 33.5887,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 104.193,
    y: 159.092,
    width: 33.5887,
    height: 33.5887,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 204.636,
    y: 125.503,
    width: 33.5887,
    height: 34.59,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 204.636,
    y: 92,
    width: 33.5887,
    height: 33.5887,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 104.193,
    y: 125.503,
    width: 33.5887,
    height: 33.5887,
    fill: "white",
    fillOpacity: 0.8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 104.193,
    y: 92,
    width: 33.5887,
    height: 33.5887,
    fill: "white",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_241_933",
    x1: 247.227,
    y1: 246.045,
    x2: 95.1365,
    y2: 93.6485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#7CFFF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_241_933",
    x1: 152.123,
    y1: 304.104,
    x2: 155.663,
    y2: 3.42395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0758875,
    stopColor: "#039790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_241_933",
    x1: 230.278,
    y1: 229.131,
    x2: 112.017,
    y2: 110.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55FFF8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.c2892e6d3e59d372824ef7d93a62d538.svg";
export { ForwardRef as ReactComponent };